var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3 3.36842H11.9V1.68421C11.9 0.749474 11.1435 0 10.2 0H6.8C5.8565 0 5.1 0.749474 5.1 1.68421V3.36842H1.7C0.7565 3.36842 0.00849999 4.11789 0.00849999 5.05263L0 14.3158C0 15.2505 0.7565 16 1.7 16H15.3C16.2435 16 17 15.2505 17 14.3158V5.05263C17 4.11789 16.2435 3.36842 15.3 3.36842ZM10.2 3.36842H6.8V1.68421H10.2V3.36842Z",
    fill: "#656A6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBag);
export default __webpack_public_path__ + "static/media/bag.7f010354d5d2cfea62f7d29478b2b90b.svg";
export { ForwardRef as ReactComponent };